export const receipt = {
  "loading": "Loading receipt...",
  "order": "Order:",
  "date": "Date:",
  "customer": "Customer:",
  "item": "Item",
  "qty": "Qty",
  "total": "Total",
  "subtotal": "Subtotal",
  "discount": "Discount",
  "tax": "Tax (7%)",
  "totalAmount": "Total",
  "thankYou": "Thank you for your visit!",
  "notFound": "Order not found."
};
